
import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { StyledLink } from "./style.css"

const Post = ({ post }) => {

  // const { small } = image.childImageSharp
  const { title, slug, acf, featured_media } = post
  const { titulo, subtitulo } = acf
  const { small } = featured_media.localFile.childImageSharp

  return (
    <StyledLink to={`/${slug}/`}>
      <div className="overlay">
        <div className="wrap">
          {
            titulo && subtitulo
            ?
            <h2 className="withSubtitle">
                <span>{titulo}</span>
              {/* <small>{subtitulo}</small> */}
            </h2>
            :
            <h2>{title}</h2>
          }
        </div>
      </div>
      <div className="bg">
        <Img fluid={{ ...small }} />
      </div>
    </StyledLink>
  )
}

export default Post

export const postFragment = graphql`
  fragment PostContent on wordpress__POST {
      title
      slug
      acf{
        titulo
        subtitulo
      }
      featured_media{
        localFile {
          childImageSharp {
            small: fluid(
              maxWidth: 320,
              maxHeight: 320,
              quality: 70,
              srcSetBreakpoints:  [ 300, 900 ]
            ){
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
  }
`